const RootWrapper = ({ children }) => {
  return (
    children
  )
}

export default RootWrapper
